import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

function InfiniteImages({ images, delay = 1000, width = 120, height = 120, style = {}, children, onPositionChange }) {
  const [idx, setIdx] = useState(0);
  const posRef = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const rafRef = useRef(null);

  // 이미지 프레임 전환
  useEffect(() => {
    if (!images || images.length <= 1) return;
    const timer = setInterval(() => {
      setIdx(prev => (prev + 1) % images.length);
    }, delay);
    return () => clearInterval(timer);
  }, [images.length, delay]);

  // 돌아다니기 애니메이션
  useEffect(() => {
    const gameRoot = document.querySelector('.game-root');
    if (!gameRoot) return;

    const getbounds = () => {
      const r = gameRoot.getBoundingClientRect();
      return { left: r.left, top: r.top, maxX: r.right - width, maxY: r.bottom - height };
    };

    if (!posRef.current) {
      const b = getbounds();
      posRef.current = {
        x: b.left + Math.random() * (b.maxX - b.left),
        y: b.top + Math.random() * (b.maxY - b.top),
        dx: (0.5 + Math.random() * 0.5) * (Math.random() > 0.5 ? 1 : -1),
        dy: (0.5 + Math.random() * 0.5) * (Math.random() > 0.5 ? 1 : -1),
      };
    }

    const animate = () => {
      const p = posRef.current;
      const b = getbounds();

      p.x += p.dx;
      p.y += p.dy;

      if (p.x <= b.left) { p.x = b.left; p.dx = Math.abs(p.dx) + (Math.random() - 0.5) * 0.5; }
      if (p.x >= b.maxX) { p.x = b.maxX; p.dx = -(Math.abs(p.dx) + (Math.random() - 0.5) * 0.5); }
      if (p.y <= b.top) { p.y = b.top; p.dy = Math.abs(p.dy) + (Math.random() - 0.5) * 0.5; }
      if (p.y >= b.maxY) { p.y = b.maxY; p.dy = -(Math.abs(p.dy) + (Math.random() - 0.5) * 0.5); }

      const maxSpeed = 1;
      p.dx = Math.max(-maxSpeed, Math.min(maxSpeed, p.dx));
      p.dy = Math.max(-maxSpeed, Math.min(maxSpeed, p.dy));

      setPos({ x: p.x, y: p.y });
      if (onPositionChange) onPositionChange({ x: p.x, y: p.y });
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [width, height]);

  return ReactDOM.createPortal(
    <div
      style={{
        width: width,
        height: height,
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        pointerEvents: 'none',
        zIndex: 100,
        ...style
      }}
    >
      {images.map((src, index) => (
        <img
          key={src}
          src={src}
          alt={`img${index + 1}`}
          width={width}
          height={height}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: index === idx ? 'block' : 'none',
            transform: posRef.current?.dx > 0 ? 'scaleX(-1)' : 'none',
          }}
        />
      ))}
      {children && (
        <div style={{ position: 'absolute', top: -30, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'auto' }}>
          {children}
        </div>
      )}
    </div>,
    document.body
  );
}

export default InfiniteImages;
